import { createAction, props } from '@ngrx/store';

export const GoogleServicesActionTypes = {
    GOOGLE_SERVICES_INIT: '[Google Services] GOOGLE_SERVICES_INIT',
    INIT_GTM_SUCCESS: '[Google Services] INIT_GTM_SUCCESS',
    INIT_GTM_ERROR: '[Google Services] INIT_GTM_ERROR',
};

export const Init = createAction(
    GoogleServicesActionTypes.GOOGLE_SERVICES_INIT
);

// #region GOOGLE TAG MANAGER
export const InitGoogleTagManagerSuccess = createAction(
    GoogleServicesActionTypes.INIT_GTM_SUCCESS
);

export const InitGoogleTagManagerError = createAction(
    GoogleServicesActionTypes.INIT_GTM_ERROR,
    props<{ error: any }>()
);
